import React from 'react';

export const DashboardBanner = ({ user }) => {
  return (
    <div className="relative overflow-hidden w-full h-32 bg-white border border-slate-200 rounded-xl flex items-center justify-between">
      {/* Left Welcome Info */}
      <div className="pl-12 z-20">
        <h1 className="font-serif font-medium text-3xl text-slate-900 tracking-wide">Dashboard</h1>
        <p className="text-sm font-body text-slate-400 mt-2 font-medium">
          Welcome, {user?.name?.split(' ')[0] || 'Admin'}
        </p>
      </div>

      {/* Right Kitchen Image Banner with seamless soft gradient overlay */}
      <div className="w-[60%] h-full relative overflow-hidden flex-shrink-0 flex justify-end items-center pr-8">
        <div className="absolute inset-0 bg-gradient-to-r from-white via-white/80 to-transparent z-10 w-48" />
        <img
          src={require('../../../assets/Images/dashboard_banner.png')}
          alt="Luxury Kitchen"
          className="absolute top-0 right-0 w-full h-full object-cover object-center"
        />
      </div>
    </div>
  );
};





